@if (departamentoAEditar.permisos != null) {
    <div id="sied" class="page-layout simple fullwidth">
        @if (departamentoAEditar.permisos === true) {
            <div fxLayout="row wrap" class="p-24">
                <!-- Contenido principal -->
                <div fxLayout="column" fxFlex="60" class="evaluation-container px-16">
                    <div fxLayout="column" class="fuse-card card-border-top card-sied card-planes-accion p-24 gap-1">
                        <!-- Título principal -->
                        @if (!objetivosRevision()) {
                            <div class="w-100-p contenedor" fxLayout="row" fxLayoutAlign="center center">
                                <div fxLayout="column" class="w-100-p" fxFlex="2 1 0" fxLayoutAlign="center center">
                                    <b style="font-size: 24px; color: var(--feedbalia-color-primary-500)">
                                        {{ departamentoNombre }}
                                    </b>
                                </div>
                            </div>
                        }
                        @if (objetivosRevision()) {
                            <div class="w-100-p contenedor" fxLayout="row" fxLayoutAlign="center center">
                                <div fxLayout="column" class="w-100-p" fxFlex="2 1 0" fxLayoutAlign="center center">
                                    <b style="font-size: 24px; color: var(--feedbalia-color-primary-500)">
                                        {{
                                            nextSelected
                                                ? "Próximos Objetivos - " + departamentoNombre
                                                : "Objetivos Actuales - " + departamentoNombre
                                        }}
                                    </b>
                                </div>
                            </div>
                            <!-- Pestañas de navegación -->
                            @if (canWrite) {
                                <div class="w-100-p contenedor" fxLayout="row" fxLayoutAlign="end end">
                                    <div
                                        fxLayout="column"
                                        class="w-100-p"
                                        fxFlex="3 1 0"
                                        fxLayoutAlign="start end"
                                        style="padding: 5px"
                                    >
                                        <button
                                            mat-raised-button
                                            color="primary"
                                            [disabled]="!nextSelected"
                                            (click)="setNextSelected(false)"
                                        >
                                            {{ "evaluation.objetivos.verActuales" | translate }}
                                        </button>
                                    </div>
                                    <div
                                        fxLayout="column"
                                        class="w-100-p"
                                        fxFlex="3 1 0"
                                        fxLayoutAlign="start start"
                                        style="padding: 5px"
                                    >
                                        <button
                                            mat-raised-button
                                            color="primary"
                                            [disabled]="nextSelected"
                                            (click)="setNextSelected(true)"
                                        >
                                            {{ "evaluation.objetivos.verProximos" | translate }}
                                        </button>
                                    </div>
                                </div>
                            }
                        }
                        @if (nextSelected) {
                            <div fxLayout="row">
                                <div fxFlex="60" fxLayout="column">
                                    <h5 class="m-0 font-size-14 text-theme">
                                        {{ "evaluation.objetivos.proximos" | translate }}
                                    </h5>
                                    <h6 class="m-0 font-size-12">Próximos objetivos del departamento</h6>
                                </div>
                                <div fxFlex="40" fxLayout="row" fxLayoutAlign="space-around center"></div>
                            </div>
                            <div fxLayout="column" class="gap-1">
                                @if (nextPDA().length < 10) {
                                    <div fxLayout="row" fxLayoutAlign="center center" class="gap-1">
                                        <mat-form-field subscriptSizing="dynamic" appearance="outline" class="w-100-p">
                                            <mat-label>{{
                                                "evaluation.actionplan.placeholder.add.title" | translate
                                            }}</mat-label>
                                            <input
                                                matInput
                                                class="gap-1"
                                                (focus)="showHelpBoxActionPlan = true"
                                                (blur)="showHelpBoxActionPlan = false"
                                                (input)="onActionPlanTitle($event)"
                                                #titleInput
                                            />
                                        </mat-form-field>
                                        <button
                                            mat-raised-button
                                            class="btn-feedbalia"
                                            [disabled]="!canCreatePlanAction()"
                                            (click)="addPABlue()"
                                        >
                                            <mat-icon>add_circle</mat-icon>
                                            {{ "evaluation.actionplan.next.add" | translate }}
                                        </button>
                                    </div>
                                } @else {
                                    <div fxLayout="row" fxLayoutAlign="center center" class="gap-1">
                                        <span style="font-style: italic">{{
                                            "evaluation.objetivos.max" | translate
                                        }}</span>
                                    </div>
                                }
                                @if (showHelpBoxActionPlan) {
                                    <div fxLayout="row" class="alert alert-info">
                                        <span
                                            >Trate de establecer objetivos claros, concisos y medibles para su
                                            departamento</span
                                        >
                                    </div>
                                }
                            </div>
                            <!-- Mensaje de recordatorio de peso -->
                            @if (checkNextPesos()) {
                                <div fxLayout="row">
                                    <b>{{ "evaluation.objetivos.recuerde" | translate }}</b>
                                </div>
                            } @else {
                                <div fxLayout="row">
                                    <b style="color: brown"
                                        >{{ "evaluation.objetivos.recuerdeActual" | translate }} {{ sumaDePesos }}%</b
                                    >
                                </div>
                            }
                            @if (mainPeriod()) {
                                <div class="container-plan-accion">
                                    @if (!nextPDA()) {
                                        <div fxLayout="row" fxLayoutAlign="center" class="spinner">
                                            <mat-spinner color="accent"></mat-spinner>
                                        </div>
                                    }
                                    @if (nextPDA()?.length && user()) {
                                        <div [@slideInRightList]>
                                            @for (itemPA of nextPDA(); track itemPA) {
                                                <div>
                                                    <action-plan-blue
                                                        [datos-plan-accion]="itemPA"
                                                        [revisionPeriodEnabled]="false"
                                                        [evpartial-id]="evPartial ? evPartial.id : null"
                                                        [period-id]="null"
                                                        [user]="user()"
                                                        [person]="person()"
                                                        [editable]="canEditPlanAction(itemPA)"
                                                        [read-only]="false"
                                                        [startPeriod]="mainPeriod()?.startPeriod"
                                                        [inEvaluation]="false"
                                                        [canBeBlocked]="canBlockPDAs()"
                                                        [permisos]="permisosPDA()"
                                                        (reload)="getActionsPlans()"
                                                        (onChangeValue)="onChangeElementValue($event)"
                                                        [fullEdit]="true"
                                                        [fullDuplicar]="false"
                                                    >
                                                    </action-plan-blue>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        } @else {
                            <div fxLayout="row">
                                <div fxFlex="60" fxLayout="column">
                                    <b style="font-size: 24px; color: var(--feedbalia-color-primary-500)">
                                        OBJETIVOS {{ evaluandose | uppercase }}
                                    </b>
                                    <h6 class="m-0 font-size-14">
                                        Estos son los objetivos definidos para tu departamento para este trimestre
                                    </h6>
                                </div>
                                <div fxFlex="40" fxLayout="row" fxLayoutAlign="space-around center">
                                    <!-- Aquí se pueden agregar métricas específicas del departamento si es necesario -->
                                </div>
                            </div>
                            <!-- Botón para ver objetivos anteriores -->
                            <div class="container-plan-accion" style="margin-top: 24px">
                                <div fxLayout="row" fxLayoutAlign="center" class="spinner">
                                    <button
                                        mat-raised-button
                                        class="btn-feedbalia w-100-p"
                                        (click)="openHistorioObjetivos()"
                                    >
                                        {{ "evaluation.objetivos.verHistorico" | translate }}
                                    </button>
                                </div>
                            </div>
                            <!-- Objetivos actuales -->
                            <div class="container-plan-accion">
                                @if (!currentPDA()?.length) {
                                    <div fxLayout="row" fxLayoutAlign="center" class="spinner">
                                        <mat-spinner color="accent"></mat-spinner>
                                    </div>
                                }
                                @if (currentPDA()?.length && user() && loaded()) {
                                    <div [@slideInRightList]>
                                        @for (itemPA of currentPDA(); track itemPA) {
                                            <div>
                                                <action-plan-blue
                                                    [datos-plan-accion]="itemPA"
                                                    [revisionPeriodEnabled]="false"
                                                    [evpartial-id]="evPartial ? evPartial.id : null"
                                                    [period-id]="null"
                                                    [user]="user()"
                                                    [person]="person()"
                                                    [editable]="canEditPlanAction(itemPA)"
                                                    [read-only]="!canWrite"
                                                    [startPeriod]="mainPeriod()?.startPeriod"
                                                    [inEvaluation]="false"
                                                    [canBeBlocked]="canBlockPDAs()"
                                                    [permisos]="permisosPDA()"
                                                    (reload)="getActionsPlans()"
                                                    (onChangeValue)="onChangeElementValue($event)"
                                                    [fullEdit]="canEditObjetivo(itemPA) && canWrite"
                                                    [fullDuplicar]="
                                                        (objetivosRevision() || mainPeriod()?.isActive) && canWrite
                                                    "
                                                    [canComment]="true"
                                                >
                                                </action-plan-blue>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        } @else {
            <div fxLayout="row" fxLayoutAlign="center center">
                <span style="font-style: italic; padding: 24px"
                    >No tienes permisos para editar los objetivos de este departamento</span
                >
            </div>
        }
    </div>
}
